import opentype from 'opentype.js';

const glyphIgnoreList = [
  'acutecomb',
  'acutecomb.case',
  'acutecomb.sc',
  'brevecomb',
  'brevecomb.case',
  'brevecomb.sc',
  'caroncomb',
  'caroncomb.case',
  'caroncomb.sc',
  'cedillacomb',
  'cedillacomb.case',
  'cedillacomb.sc',
  'circumflexcomb',
  'circumflexcomb.case',
  'circumflexcomb.sc',
  'dieresiscomb',
  'dieresiscomb.case',
  'dieresiscomb.sc',
  'gravecomb',
  'gravecomb.case',
  'gravecomb.sc',
  'hungarumlautcomb',
  'hungarumlautcomb.case',
  'hungarumlautcomb.sc',
  'macroncomb',
  'macroncomb.case',
  'macroncomb.sc',
  'ogonekcomb',
  'ogonekcomb.case',
  'ogonekcomb.sc',
  'ringcomb',
  'ringcomb.case',
  'ringcomb.sc',
  'tildecomb',
  'tildecomb.case',
  'tildecomb.sc',
  'dotaccentcomb',
  'dotaccentcomb.case',
  'dotaccentcomb.sc',
  'periodcenteredcomb',
  'periodcenteredcomb.case',
  'periodcenteredcomb.sc',
  'caroncomb.alt',
  'caroncombcase',
  'caroncombcase.case',
  'caroncombcase.sc',
  'commaturnedabovecomb',
  'commaturnedabovecomb.case',
  'commaturnedabovecomb.sc',
  'commaaccentcomb',
  'commaaccentcomb.case',
  'commaaccentcomb.sc',
  'uni0306',
  'uni0306.case',
  'uni030C',
  'uni030C.case',
  'uni0327',
  'uni0327.case',
  'uni0302',
  'uni0302.case',
  'uni0308',
  'uni0308.case',
  'uni030B',
  'uni030B.case',
  'uni0304',
  'uni0304.case',
  'uni0328',
  'uni0328.case',
  'uni030A',
  'uni030A.case',
  'uni0307',
  'uni0307.case',
  'uni030C.alt',
  'uni0312.1',
  'uni0312',
  'uni0312.case',
  'uni0326.1',
  'uni0326',
  'uni0326.case',
];

// const glyphTypes = {
//   'Uppercase' : ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'],
//   'Lowercase' : ['a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z'],
//   'Standard Punctuation' : ['period', 'comma', 'colon', 'semicolon', 'ellipsis', 'question', 'exclam', 'questiondown', 'exclamdown', 'parenleft', 'parenright', 'braceleft', 'braceright', 'bracketleft', 'bracketright', 'slash', 'backslash', 'underscore', 'hyphen', 'endash', 'emdash', 'brokenbar', 'bar', 'apostrophe', 'guillemotleft', 'guillemotright', 'guilsinglleft', 'guilsinglright', 'quotesinglbase', 'quotedblbase', 'quoteleft', 'quotedblleft', 'quoteright', 'quotedblright', 'quotesingle', 'quotedbl', 'bullet', 'ampersand', 'paragraph', 'dagger', 'daggerdbl', 'section', 'asterisk', 'trademark', 'registered', 'copyright', 'product', 'at', 'ordfeminine', 'ordmasculine'],
//   'Currency & Maths Glyphs' : ['numbersign', 'uni20BF', 'uni20BD', 'Euro', 'dollar', 'yen', 'sterling', 'sterling.alt', 'cent', 'florin', 'currency', 'plus', 'minus', 'multiply', 'divide', 'equal', 'logicalnot', 'asciitilde', 'less', 'greater', 'plusminus', 'asciicircum', 'notequal', 'approxequal', 'lessequal', 'greaterequal', 'infinity', 'lozenge', 'radical', 'integral', 'pi', 'mu', 'summation', 'Omega', 'Delta', 'uni2113', 'estimated'],
//   'All Cap Punctuation' : ['questiondown.case', 'exclamdown.case', 'hyphen.case', 'endash.case', 'emdash.case', 'guillemotleft.case', 'guillemotright.case', 'guilsinglleft.case', 'guilsinglright.case', 'bar.case', 'braceleft.case', 'braceright.case', 'bracketleft.case', 'bracketright.case', 'parenleft.case', 'parenright.case'],
//   'Stylistic Alternatives' : ['a.001', 'b.001', 'c.001', 'd.001', 'e.001', 'f.001', 'g.001', 'h.001', 'i.001', 'j.001', 'k.001', 'l.001', 'm.001', 'n.001', 'o.001', 'p.001', 'q.001', 'r.001', 's.001', 't.001', 'u.001', 'v.001', 'w.001', 'x.001', 'y.001', 'z.001','uniE000', 'uniE001', 'uniE002', 'uniE003', 'uniE004', 'uniE005', 'uniE006', 'uniE007', 'uniE008', 'uniE009', 'uniE010', 'uniE011', 'uniE012', 'uniE013', 'f.short', 'j.short', 'c_t', 's_t'],
//   'Ligatures' : ['T_h', 'T_i', 'ct', 'st', 'fi', 'fl','ff', 'ffi', 'ffj', 'ffl', 'fft', 'f_b', 'f_f', 'f_h', 'f_i', 'f_j', 'f_k', 'f_l', 'f_t', 'f_f_b', 'f_f_f', 'f_f_h', 'f_f_i', 'f_f_j', 'f_f_k', 'f_f_l', 'f_f_t', 'g_g', 'g_i', 'g_y', 'g_j', 'j_j', 't_t'],
//   'Standard Lining Figures' : ['zero.alt', 'one.alt', 'two.alt', 'three.alt', 'four.alt', 'five.alt', 'six.alt', 'seven.alt', 'eight.alt', 'nine.alt', 'zero.lf', 'one.lf', 'two.lf', 'three.lf', 'four.lf', 'five.lf', 'six.lf', 'seven.lf', 'eight.lf', 'nine.lf'],
//   'Tabular Figures' : ['zero', 'one', 'two', 'three', 'four', 'five', 'six', 'seven', 'eight', 'nine', 'zero.tnum', 'one.tnum', 'two.tnum', 'three.tnum', 'four.tnum', 'five.tnum', 'six.tnum', 'seven.tnum', 'eight.tnum', 'nine.tnum'],
//   'Oldstyle Figures' : ['zero.posf', 'one.posf', 'two.posf', 'three.posf', 'four.posf', 'five.posf', 'six.posf', 'seven.posf', 'eight.posf', 'nine.posf',  'zero.pnum', 'one.pnum', 'two.pnum', 'three.pnum', 'four.pnum', 'five.pnum', 'six.pnum', 'seven.pnum', 'eight.pnum', 'nine.pnum', 'zero.onum', 'one.onum', 'two.onum', 'three.onum', 'four.onum', 'five.onum', 'six.onum', 'seven.onum', 'eight.onum', 'nine.onum', 'zero.osf', 'one.osf', 'two.osf', 'three.osf', 'four.osf', 'five.osf', 'six.osf', 'seven.osf', 'eight.osf', 'nine.osf'],
//   'Fractions' : ['onehalf', 'onequarter', 'threequarters', 'onethird', 'twothirds', 'oneeighth', 'threeeighths', 'fiveeighths', 'seveneighths', 'oneeight', 'threeeights', 'fiveeights', 'seveneights', 'onefifth', 'twofifths', 'threefifths', 'fourfifths', 'onesixth',  'fivesixths', 'oneseventh', 'twosevenths', 'threesevenths', 'foursevenths', 'fivesevenths', 'sixsevenths', 'oneninth', 'twoninths', 'fourninths', 'fiveninths', 'sevenninths', 'eightninths'],
//   'Numerators Denominators' : ['zero.numerator', 'one.numerator', 'two.numerator', 'three.numerator', 'four.numerator', 'five.numerator', 'six.numerator', 'seven.numerator', 'eight.numerator', 'nine.numerator', 'zero.denominator', 'one.denominator', 'two.denominator', 'three.denominator', 'four.denominator', 'five.denominator', 'six.denominator', 'seven.denominator', 'eight.denominator', 'nine.denominator'],
//   'Superscript & Subscript Figures' : ['zerosuperior', 'onesuperior', 'twosuperior', 'threesuperior', 'foursuperior', 'fivesuperior', 'sixsuperior', 'sevensuperior', 'eightsuperior', 'ninesuperior','zeroinferior', 'oneinferior', 'twoinferior', 'threeinferior', 'fourinferior', 'fiveinferior', 'sixinferior', 'seveninferior', 'eightinferior', 'nineinferior', 'zero.dnom', 'one.dnom', 'two.dnom', 'three.dnom', 'four.dnom', 'five.dnom', 'six.dnom', 'seven.dnom', 'eight.dnom', 'nine.dnom', 'zero.numr', 'one.numr', 'two.numr', 'three.numr', 'four.numr', 'five.numr', 'six.numr', 'seven.numr', 'eight.numr', 'nine.numr'],
//   'Accented Uppercase' : ['AE', 'OE', 'Lslash', 'Oslash', 'Eth', 'Thorn', 'Aacute', 'Acircumflex', 'Adieresis', 'Agrave', 'Aring', 'Atilde', 'Abreve', 'Amacron', 'Aogonek', 'Ccedilla', 'Cacute', 'Ccaron', 'Ccircumflex', 'Cdotaccent', 'Dcaron', 'Dcroat', 'Eacute', 'Ecircumflex', 'Edieresis', 'Egrave', 'Ebreve', 'Ecaron', 'Edotaccent', 'Emacron', 'Eogonek', 'Gbreve', 'Gcircumflex', 'Gcommaaccent', 'Gdotaccent', 'Hbar', 'Hcircumflex', 'Iacute', 'Icircumflex', 'Idieresis', 'Igrave', 'Ibreve', 'Idotaccent', 'Imacron', 'Iogonek', 'Itilde', 'Jcircumflex', 'IJ', 'Kcommaaccent', 'Lacute', 'Lcaron', 'Lcommaaccent', 'Ldot', 'Ntilde', 'Nacute', 'Ncaron', 'Ncommaaccent', 'Eng', 'Oacute', 'Ocircumflex', 'Odieresis', 'Ograve', 'Otilde', 'Obreve', 'Ohungarumlaut', 'Omacron', 'Racute', 'Rcaron', 'Rcommaaccent', 'Scaron', 'Sacute', 'Scedilla', 'Scircumflex', 'Scommaaccent', 'Tbar', 'Tcaron', 'Tcommaaccent', 'uni021A', 'Uacute', 'Ucircumflex', 'Udieresis', 'Ugrave', 'Ubreve', 'Uhungarumlaut', 'Umacron', 'Uogonek', 'Uring', 'Utilde', 'Wacute', 'Wcircumflex', 'Wdieresis', 'Wgrave', 'Yacute', 'Ydieresis', 'Ycircumflex', 'Ygrave', 'Zcaron', 'Zacute', 'Zdotaccent'],
//   'Accented Lowercase' : ['ae', 'oe', 'lslash', 'oslash', 'eth', 'partialdiff', 'thorn', 'germandbls', 'longs', 'dotlessi', 'dotlessj', 'aacute', 'acircumflex', 'adieresis', 'agrave', 'aring', 'atilde', 'abreve', 'amacron', 'aogonek', 'aacute.001', 'acircumflex.001', 'adieresis.001', 'agrave.001', 'aring.001', 'atilde.001', 'abreve.001', 'amacron.001', 'aogonek.001','ccedilla', 'cacute', 'ccaron', 'ccircumflex', 'cdotaccent', 'dcaron', 'dcroat', 'eacute', 'ecircumflex', 'edieresis', 'egrave', 'ebreve', 'ecaron', 'edotaccent', 'emacron', 'eogonek', 'gbreve', 'gcircumflex', 'gcommaaccent', 'gdotaccent', 'hbar', 'hcircumflex', 'iacute', 'icircumflex', 'idieresis', 'igrave', 'ibreve', 'imacron', 'iogonek', 'itilde', 'jcircumflex', 'ij', 'kcommaaccent', 'kgreenlandic', 'lacute', 'lcaron', 'lcommaaccent', 'ldot', 'ntilde', 'nacute', 'ncaron', 'ncommaaccent', 'eng', 'napostrophe', 'oacute', 'ocircumflex', 'odieresis', 'ograve', 'otilde', 'obreve', 'ohungarumlaut', 'omacron', 'racute', 'rcaron', 'rcommaaccent', 'racute.001', 'rcaron.001', 'rcommaaccent.001', 'scaron', 'sacute', 'scedilla', 'scircumflex', 'scommaaccent', 'tbar', 'tcaron', 'tcommaaccent', 'uni021B', 'uacute', 'ucircumflex', 'udieresis', 'ugrave', 'ubreve', 'uhungarumlaut', 'umacron', 'uogonek', 'uring', 'utilde', 'wacute', 'wcircumflex', 'wdieresis', 'wgrave', 'yacute', 'ydieresis', 'ycircumflex', 'ygrave', 'zcaron', 'zacute', 'zdotaccent'],
//   'Accents' : ['acute', 'grave', 'circumflex', 'caron', 'tilde', 'dieresis', 'ring', 'cedilla', 'hungarumlaut', 'breve', 'macron', 'dotaccent', 'periodcentered', 'ogonek', 'commaaccent', 'revcommaaccent', 'apostrophemod'],
//   'Small Caps' : ['A.smcp', 'B.smcp', 'C.smcp', 'D.smcp', 'E.smcp', 'F.smcp', 'G.smcp', 'H.smcp', 'I.smcp', 'J.smcp', 'K.smcp', 'L.smcp', 'M.smcp', 'N.smcp', 'O.smcp', 'P.smcp', 'Q.smcp', 'R.smcp', 'S.smcp', 'T.smcp', 'U.smcp', 'V.smcp', 'W.smcp', 'X.smcp', 'Y.smcp', 'Z.smcp', 'Germandbls.smcp', 'AE.smcp', 'OE.smcp', 'Lslash.smcp', 'Oslash.smcp', 'Eth.smcp', 'Thorn.smcp', 'a.sc', 'b.sc', 'c.sc', 'd.sc', 'e.sc', 'f.sc', 'g.sc', 'h.sc', 'i.sc', 'j.sc', 'k.sc', 'l.sc', 'm.sc', 'n.sc', 'o.sc', 'p.sc', 'q.sc', 'r.sc', 's.sc', 't.sc', 'u.sc', 'v.sc', 'w.sc', 'x.sc', 'y.sc', 'z.sc', 'germandbls.sc', 'ae.sc', 'oe.sc', 'lslash.sc', 'oslash.sc', 'eth.sc', 'thorn.sc'],
//   'Accented Small Caps' : ['Aacute.smcp', 'Acircumflex.smcp', 'Adieresis.smcp', 'Agrave.smcp', 'Aring.smcp', 'Atilde.smcp', 'Abreve.smcp', 'Amacron.smcp', 'Aogonek.smcp', 'Ccedilla.smcp', 'Cacute.smcp', 'Ccaron.smcp', 'Ccircumflex.smcp', 'Cdotaccent.smcp', 'Dcaron.smcp', 'Dcroat.smcp', 'Eacute.smcp', 'Ecircumflex.smcp', 'Edieresis.smcp', 'Egrave.smcp', 'Ebreve.smcp', 'Ecaron.smcp', 'Edotaccent.smcp', 'Emacron.smcp', 'Eogonek.smcp', 'Gbreve.smcp', 'Gcircumflex.smcp', 'Gcommaaccent.smcp', 'Gdotaccent.smcp', 'Hbar.smcp', 'Hcircumflex.smcp', 'Iacute.smcp', 'Icircumflex.smcp', 'Idieresis.smcp', 'Igrave.smcp', 'Ibreve.smcp', 'Idotaccent.smcp', 'Imacron.smcp', 'Iogonek.smcp', 'Itilde.smcp', 'Jcircumflex.smcp', 'IJ.smcp', 'Kcommaaccent.smcp', 'Lacute.smcp', 'Lcaron.smcp', 'Lcommaaccent.smcp', 'Ldot.smcp', 'Ntilde.smcp', 'Nacute.smcp', 'Ncaron.smcp', 'Ncommaaccent.smcp', 'Eng.smcp', 'Oacute.smcp', 'Ocircumflex.smcp', 'Odieresis.smcp', 'Ograve.smcp', 'Otilde.smcp', 'Obreve.smcp', 'Ohungarumlaut.smcp', 'Omacron.smcp', 'Racute.smcp', 'Rcaron.smcp', 'Rcommaaccent.smcp', 'Scaron.smcp', 'Sacute.smcp', 'Scedilla.smcp', 'Scircumflex.smcp', 'Scommaaccent.smcp', 'Tbar.smcp', 'Tcaron.smcp', 'Tcommaaccent.smcp', 'uni021A.smcp', 'Uacute.smcp', 'Ucircumflex.smcp', 'Udieresis.smcp', 'Ugrave.smcp', 'Ubreve.smcp', 'Uhungarumlaut.smcp', 'Umacron.smcp', 'Uogonek.smcp', 'Uring.smcp', 'Utilde.smcp', 'Wacute.smcp', 'Wcircumflex.smcp', 'Wdieresis.smcp', 'Wgrave.smcp', 'Yacute.smcp', 'Ydieresis.smcp', 'Ycircumflex.smcp', 'Ygrave.smcp', 'Zcaron.smcp', 'Zacute.smcp', 'Zdotaccent.smcp', 'aacute.sc', 'acircumflex.sc', 'adieresis.sc', 'agrave.sc', 'aring.sc', 'atilde.sc', 'abreve.sc', 'amacron.sc', 'aogonek.sc', 'ccedilla.sc', 'cacute.sc', 'ccaron.sc', 'ccircumflex.sc', 'cdotaccent.sc', 'dcaron.sc', 'dcroat.sc', 'eacute.sc', 'ecircumflex.sc', 'edieresis.sc', 'egrave.sc', 'ebreve.sc', 'ecaron.sc', 'edotaccent.sc', 'emacron.sc', 'eogonek.sc', 'gbreve.sc', 'gcircumflex.sc', 'gcommaaccent.sc', 'gdotaccent.sc', 'hbar.sc', 'hcircumflex.sc', 'iacute.sc', 'icircumflex.sc', 'idieresis.sc', 'igrave.sc', 'ibreve.sc', 'idotaccent.sc', 'imacron.sc', 'iogonek.sc', 'itilde.sc', 'jcircumflex.sc', 'ij.sc', 'kcommaaccent.sc', 'lacute.sc', 'lcaron.sc', 'lcommaaccent.sc', 'ldot.sc', 'ntilde.sc', 'nacute.sc', 'ncaron.sc', 'ncommaaccent.sc', 'eng.sc', 'oacute.sc', 'ocircumflex.sc', 'odieresis.sc', 'ograve.sc', 'otilde.sc', 'obreve.sc', 'ohungarumlaut.sc', 'omacron.sc', 'racute.sc', 'rcaron.sc', 'rcommaaccent.sc', 'scaron.sc', 'sacute.sc', 'scedilla.sc', 'scircumflex.sc', 'scommaaccent.sc', 'tbar.sc', 'tcaron.sc', 'tcommaaccent.sc', 'uni021a.sc', 'uacute.sc', 'ucircumflex.sc', 'udieresis.sc', 'ugrave.sc', 'ubreve.sc', 'uhungarumlaut.sc', 'umacron.sc', 'uogonek.sc', 'uring.sc', 'utilde.sc', 'wacute.sc', 'wcircumflex.sc', 'wdieresis.sc', 'wgrave.sc', 'yacute.sc', 'ydieresis.sc', 'ycircumflex.sc', 'ygrave.sc', 'zcaron.sc', 'zacute.sc', 'zdotaccent.sc'],
//   'Small Caps Standard Punctuation' : ['ampersand.smcp', 'question.smcp', 'exclam.smcp', 'questiondown.smcp', 'exclamdown.smcp', 'parenleft.smcp', 'parenright.smcp', 'braceleft.smcp', 'braceright.smcp', 'bracketleft.smcp', 'bracketright.smcp', 'slash.smcp', 'backslash.smcp', 'bar.smcp', 'brokenbar.smcp', 'numbersign.smcp', 'uni20BF.smcp', 'uni20BD.smcp', 'Euro.smcp', 'dollar.smcp', 'yen.smcp', 'sterling.smcp', 'cent.smcp', 'florin.smcp', 'ampersand.sc', 'question.sc', 'exclam.sc', 'questiondown.sc', 'exclamdown.sc', 'parenleft.sc', 'parenright.sc', 'braceleft.sc', 'braceright.sc', 'bracketleft.sc', 'bracketright.sc', 'slash.sc', 'backslash.sc', 'bar.sc', 'brokenbar.sc', 'numbersign.sc', 'uni20bf.sc', 'uni20bd.sc', 'bitcoin.sc', 'ruble.sc', 'euro.sc', 'dollar.sc', 'yen.sc', 'sterling.sc', 'cent.sc', 'florin.sc'],
//   'Small Caps Figures' : ['zero.smcp', 'one.smcp', 'two.smcp', 'three.smcp', 'four.smcp', 'five.smcp', 'six.smcp', 'seven.smcp', 'eight.smcp', 'nine.smcp', 'percent.smcp', 'perthousand.smcp', 'zero.sc', 'one.sc', 'two.sc', 'three.sc', 'four.sc', 'five.sc', 'six.sc', 'seven.sc', 'eight.sc', 'nine.sc', 'percent.sc', 'perthousand.sc'],
//   'Uppercase Swash Glyphs' : ['A.swash', 'B.swash', 'C.swash', 'D.swash', 'E.swash', 'F.swash', 'G.swash', 'I.swash', 'J.swash', 'K.swash', 'L.swash', 'M.swash', 'N.swash', 'P.swash', 'Q.swash', 'R.swash', 'S.swash', 'T.swash', 'U.swash', 'Y.swash', 'Z.swash'],
//   'Lowercase Swash Glyphs' : ['h.swash', 'k.swash', 'v.swash', 'w.swash'],
//   'Directionals' : ['less.alt', 'greater.alt', 'arrowleft', 'arrowright', 'arrowup', 'arrowdown', 'arrowupleft', 'arrowupright', 'arrowdownleft', 'arrowdownright', 'arrow.left', 'arrow.right', 'arrow.up', 'arrow.down', 'arrowup.left', 'arrowup.right', 'arrowdown.left', 'arrowdown.right', 'northWestArrow', 'northEastArrow', 'southWestArrow', 'southEastArrow','uni2196','uni2197','uni2199','uni2198'],
//   'Ornaments' : ['filledbox', 'uni25CF', 'triagdn', 'triagup', 'uni25B6', 'uni25C0', 'uni2B24', 'orn1', 'orn2', 'orn3', 'orn4', 'orn5', 'orn6', 'orn7', 'orn8', 'orn9', 'orn10', 'orn.1', 'orn.2', 'orn.3', 'orn.4', 'orn.5', 'orn.6', 'orn.7', 'orn.8', 'orn.9', 'orn.10', 'orn.001', 'orn.002', 'orn.003', 'orn.004', 'orn.005', 'orn.006', 'orn.007', 'orn.008', 'orn.009', 'orn.010','uniE00D','uniE00E','uniE00F','uniF00A','uniF00B','uniF00C', 'logo'],
// };

let fontRef = null;
// let glyphCloseUp = document.querySelector('[data-glyph-closeup]');
// let unicodeContainer = document.querySelector('[data-glyph-unicode]');

function enableHighDPICanvas(canvas) {
  if (typeof canvas === 'string') {
    canvas = document.getElementById(canvas);
  }
  let pixelRatio = window.devicePixelRatio || 1;
  if (pixelRatio === 1) return;
  let oldWidth = canvas.width;
  let oldHeight = canvas.height;
  canvas.width = oldWidth * pixelRatio;
  canvas.height = oldHeight * pixelRatio;
  // canvas.style.width = oldWidth + 'px';
  // canvas.style.height = oldHeight + 'px';
  canvas.getContext('2d').scale(pixelRatio, pixelRatio);
}

// Create a canvas and adds it to the document.
// Returns the 2d drawing context.
function createGlyphCanvas(glyphsDiv, glyph, size) {
  let canvasId, html, wrap, canvas, ctx, pixelRatio;
  canvasId = 'c' + glyph.index;
  // html = '<div class="wrapper bg-a2pink-30 max-w-[150px]"><canvas id="' + canvasId + '" width="' + size + '" height="' + size + '"></canvas><span class="text-center block my-1 text-sm">' + glyph.name + '</span></div>';
  html = '<canvas class="w-full" id="' + canvasId + '" width="' + size + '" height="' + size + '" title="' + glyph.name + '"></canvas>';
  wrap = document.createElement('div');
  wrap.classList.add('bg-a2black-15');
  wrap.innerHTML = html;
  glyphsDiv.appendChild(wrap);
  canvas = document.getElementById(canvasId);
  ctx = canvas.getContext('2d');
  // enableHighDPICanvas(canvas, ctx);
  return ctx;
}

function showErrorMessage(message) {
  let el = document.getElementById('message');
  if (!message || message.trim().length === 0) {
    el.style.display = 'none';
  } else {
    el.style.display = 'block';
  }
  el.innerHTML = message;
}

function getCapHeight(font) {
  const chars = 'HIKLEFJMNTZBDPRAGOQSUVWXY';

  let heights = [];

  for (let a = 0, al = chars.length; a < al; a++) {
    const idx = font.charToGlyphIndex(chars[a]);

    if (idx <= 0) continue;

    heights.push(font.glyphs.get(idx).getMetrics().yMax);
  }

  return Math.max(...heights);
}

function getXHeight(font) {
  const chars = 'xyvw';

  let heights = [];

  for (let a = 0, al = chars.length; a < al; a++) {
    const idx = font.charToGlyphIndex(chars[a]);

    if (idx <= 0) continue;

    heights.push(font.glyphs.get(idx).getMetrics().yMax);
  }

  return Math.max(...heights);
}

function onFontLoaded(font) {
  let glyphsDiv, i, x, y, fontSize;
  window.font = font;

  glyphsDiv = document.getElementById('glyphs');
  // glyphsDiv.innerHTML = '';

  y = 112;
  fontSize = 100;

  let capHeight = Math.round(getCapHeight(font) / font.unitsPerEm * fontSize);
  let xHeight = Math.round(getXHeight(font) / font.unitsPerEm * fontSize);

  // for (let [key, value] of Object.entries(glyphTypes)) {
  //   let addCatHeader = true;
  //   value.forEach(function(glyf) {
  //     let glyphIndex = font.nameToGlyphIndex(glyf);
  //     if (glyphIndex !== -1) {
  //       if (addCatHeader) {
  //         let glyphCatHeader = document.createElement('div');
  //         glyphCatHeader.classList.add('col-span-9','md:col-[span_15]','mt-4');
  //         glyphCatHeader.innerText = key;
  //         glyphsDiv.appendChild(glyphCatHeader);
  //         addCatHeader = false;
  //       }
  //       let glyph = font.nameToGlyph(glyf);
  //       let ctx = createGlyphCanvas(glyphsDiv, glyph, 150);
  //       let bb = glyph.getBoundingBox();
  //       let width = Math.round((bb.x2 - bb.x1) / font.unitsPerEm * fontSize);
  //       // let leftSideBearing = Math.round(bb.x1 / font.unitsPerEm * fontSize);
  //       // let rightSideBearing = Math.round(bb.x2 / font.unitsPerEm * fontSize);
  //       let leftSideBearing = Math.round(glyph.xMin / font.unitsPerEm * fontSize);
  //       let rightSideBearing = Math.round(glyph.xMax / font.unitsPerEm * fontSize);
  //       // let glyphLeftSideBearing = Math.round(glyph.leftSideBearing / font.unitsPerEm * fontSize);
  //       // console.log(`leftSideBearing: ${leftSideBearing}`);
  //       // console.log(`glyphLeftSideBearing: ${glyphLeftSideBearing}`);
  //       // draw x-height
  //       ctx.beginPath();
  //       ctx.moveTo(0, (y - xHeight));
  //       ctx.lineTo(150, (y - xHeight));
  //       ctx.closePath();
  //       ctx.strokeStyle = "rgba(255,255,255,0.9)";
  //       ctx.stroke();
  //       // draw cap height
  //       ctx.beginPath();
  //       ctx.moveTo(0, (y - capHeight));
  //       ctx.lineTo(150, (y - capHeight));
  //       ctx.closePath();
  //       ctx.strokeStyle = "rgba(255,255,255,0.9)";
  //       ctx.stroke();
  //       // // draw glyph left side bearing
  //       // ctx.beginPath();
  //       // ctx.moveTo((glyphLeftSideBearing + ((150 - width) / 2)), 0);
  //       // ctx.lineTo((glyphLeftSideBearing + ((150 - width) / 2)), 150);
  //       // ctx.closePath();
  //       // ctx.strokeStyle = "rgba(255,0,0,0.9)";
  //       // ctx.stroke();
  //       // draw left side bearing
  //       ctx.beginPath();
  //       ctx.moveTo((leftSideBearing + ((150 - width) / 2)), 0);
  //       ctx.lineTo((leftSideBearing + ((150 - width) / 2)), 150);
  //       ctx.closePath();
  //       ctx.strokeStyle = "rgba(255,255,255,0.9)";
  //       ctx.stroke();
  //       // draw right side bearing
  //       ctx.beginPath();
  //       ctx.moveTo((rightSideBearing + ((150 - width) / 2)), 0);
  //       ctx.lineTo((rightSideBearing + ((150 - width) / 2)), 150);
  //       ctx.closePath();
  //       ctx.strokeStyle = "rgba(255,255,255,0.9)";
  //       ctx.stroke();
  //       // draw baseline
  //       ctx.beginPath();
  //       ctx.moveTo(0, y);
  //       ctx.lineTo(150, y);
  //       ctx.closePath();
  //       ctx.strokeStyle = "rgba(255,255,255,0.9)";
  //       ctx.stroke();
  //       // draw glyph
  //       glyph.draw(ctx, (150 - width) / 2, y, fontSize);
  //     }
  //   });
  // }

  Object.entries(font.glyphs.glyphs).forEach(([key, value]) => {
    let glyph = value;
    let glyphName = glyph.name;

    if (glyphIgnoreList.indexOf(glyphName) === -1) {
      let ctx = createGlyphCanvas(glyphsDiv, glyph, 150);
      let bb = glyph.getBoundingBox();
      let width = Math.round(glyph.advanceWidth / font.unitsPerEm * fontSize);
      let leftSideBearing = ((150 - width) / 2);
      let rightSideBearing = Math.round(glyph.advanceWidth / font.unitsPerEm * fontSize);
      // draw x-height
      ctx.beginPath();
      ctx.moveTo(0, (y - xHeight));
      ctx.lineTo(150, (y - xHeight));
      ctx.closePath();
      ctx.strokeStyle = "rgba(255,255,255,0.9)";
      ctx.stroke();
      // draw cap height
      ctx.beginPath();
      ctx.moveTo(0, (y - capHeight));
      ctx.lineTo(150, (y - capHeight));
      ctx.closePath();
      ctx.strokeStyle = "rgba(255,255,255,0.9)";
      ctx.stroke();
      // draw left side bearing
      ctx.beginPath();
      ctx.moveTo(leftSideBearing, 0);
      ctx.lineTo(leftSideBearing, 150);
      ctx.closePath();
      ctx.strokeStyle = "rgba(255,255,255,0.9)";
      ctx.stroke();
      // draw right side bearing
      ctx.beginPath();
      ctx.moveTo((rightSideBearing + ((150 - width) / 2)), 0);
      ctx.lineTo((rightSideBearing + ((150 - width) / 2)), 150);
      ctx.closePath();
      ctx.strokeStyle = "rgba(255,255,255,0.9)";
      ctx.stroke();
      // draw baseline
      ctx.beginPath();
      ctx.moveTo(0, y);
      ctx.lineTo(150, y);
      ctx.closePath();
      ctx.strokeStyle = "rgba(255,255,255,0.9)";
      ctx.stroke();
      glyph.draw(ctx, (150 - width) / 2, y, fontSize);
    }
  })
}

function onReadFile(e) {
  document.getElementById('font-name').innerHTML = '';
  let file = e.target.files[0];
  let reader = new FileReader();
  reader.onload = function(e) {
    try {
      font = opentype.parse(e.target.result);
      onFontLoaded(font);
      // showErrorMessage('');
    } catch (err) {
      console.log(err.toString());
      // showErrorMessage(err.toString());
    }
  };
  reader.onerror = function(err) {
    showErrorMessage(err.toString());
  };

  reader.readAsArrayBuffer(file);
}

let glyphSetContainer = document.querySelector('[data-glyphs]');

if (glyphSetContainer) {
  let fontFileName = glyphSetContainer.dataset.glyphs;

  opentype.load(fontFileName, function(err, font) {
    if (err) {
      console.log(err.toString());
      // showErrorMessage(err.toString());
      return;
    }
    fontRef = font;
    onFontLoaded(font);
  });

  // document.addEventListener('click', function(ev) {
  //   if (ev.target.matches('canvas')) {
  //     glyphCloseUp.innerHTML = ev.target.outerHTML;
  //     let cnvs = glyphCloseUp.querySelector('canvas');
  //     cnvs.classList.add('bg-a2black-15');
  //     let cnvsWidth = cnvs.clientWidth;
  //     cnvs.width = cnvsWidth;
  //     cnvs.height = cnvsWidth;
  //     let y = Math.round(cnvsWidth * 112 / 150);
  //     let fontSize = Math.round(cnvsWidth * 100 / 150);
  //     let capHeight = Math.round(getCapHeight(font) / font.unitsPerEm * fontSize);
  //     let xHeight = Math.round(getXHeight(font) / font.unitsPerEm * fontSize);
  //     let glyph = fontRef.nameToGlyph(ev.target.title);
  //     let ctx = cnvs.getContext('2d');
  //     let bb = glyph.getBoundingBox();
  //     let width = Math.round((bb.x2 - bb.x1) / font.unitsPerEm * fontSize);
  //     let leftSideBearing = Math.round(glyph.xMin / font.unitsPerEm * fontSize);
  //     let rightSideBearing = Math.round(glyph.xMax / font.unitsPerEm * fontSize);
  //     // draw x-height
  //     ctx.beginPath();
  //     ctx.moveTo(0, (y - xHeight));
  //     ctx.lineTo(cnvsWidth, (y - xHeight));
  //     ctx.closePath();
  //     ctx.strokeStyle = "rgba(255,255,255,0.9)";
  //     ctx.stroke();
  //     // draw cap height
  //     ctx.beginPath();
  //     ctx.moveTo(0, (y - capHeight));
  //     ctx.lineTo(cnvsWidth, (y - capHeight));
  //     ctx.closePath();
  //     ctx.strokeStyle = "rgba(255,255,255,0.9)";
  //     ctx.stroke();
  //     // draw left side bearing
  //     ctx.beginPath();
  //     ctx.moveTo((leftSideBearing + ((cnvsWidth - width) / 2)), 0);
  //     ctx.lineTo((leftSideBearing + ((cnvsWidth - width) / 2)), cnvsWidth);
  //     ctx.closePath();
  //     ctx.strokeStyle = "rgba(255,255,255,0.9)";
  //     ctx.stroke();
  //     // draw right side bearing
  //     ctx.beginPath();
  //     ctx.moveTo((rightSideBearing + ((cnvsWidth - width) / 2)), 0);
  //     ctx.lineTo((rightSideBearing + ((cnvsWidth - width) / 2)), cnvsWidth);
  //     ctx.closePath();
  //     ctx.strokeStyle = "rgba(255,255,255,0.9)";
  //     ctx.stroke();
  //     // draw baseline
  //     ctx.beginPath();
  //     ctx.moveTo(0, y);
  //     ctx.lineTo(cnvsWidth, y);
  //     ctx.closePath();
  //     ctx.strokeStyle = "rgba(255,255,255,0.9)";
  //     ctx.stroke();
  //     // draw glyph
  //     glyph.draw(ctx, (cnvsWidth - width) / 2, y, fontSize);
  //     // unicodeContainer.parentNode.classList.remove('hidden');
  //     // unicodeContainer.innerText = glyph.unicode ? glyph.unicode : '\u00A0';
  //   }
  // });

  // document.addEventListener('mouseout', function(ev) {
  //   if (ev.target.matches('canvas')) {
  //     glyphCloseUp.innerHTML = '';
  //   }
  // });
}

/******************************************
 * Typeface intro and initials
 *
 ******************************************/
const initials = document.querySelector('[data-initials]');

if (initials) {
  let initialsChars = initials.dataset.initials;
  let initialsTypeface = initials.dataset.initialsTypeface;
  let uppercase = initials.dataset.uppercase;

  if (uppercase) {
    initialsChars.toUpperCase();
  }

  opentype.load(initialsTypeface, function(err, font) {
    if (err) {
      console.log(err.toString());
      // showErrorMessage(err.toString());
      return;
    }
    displayInitials(initials, font, initialsChars);
  });

  window.addEventListener('resize', function(e) {
    displayInitials(initials, font, initialsChars);
  });
}

function displayInitials(initialsContainer, font, initialsChars) {
  let initialsCanvas = initialsContainer.querySelector('canvas');
  initialsCanvas.width = initialsContainer.clientWidth;
  initialsCanvas.height = initialsContainer.clientWidth * 1.5;
  let initialsCtx = initialsCanvas.getContext('2d');
  let fontSize = 1000;

  let capHeight = Math.round(getCapHeight(font) / font.unitsPerEm * fontSize);

  let path = font.getPath(initialsChars, initialsCanvas.width * 0.1, initialsCanvas.height * 0.9, fontSize, {});
  let bbox = path.getBoundingBox();
  let scale = Math.min(initialsCanvas.width * 0.8 / (bbox.x2 - bbox.x1), initialsCanvas.height * 0.8 / (bbox.y2 - bbox.y1));
  fontSize = scale * font.unitsPerEm;

  capHeight = Math.round(getCapHeight(font) / font.unitsPerEm * fontSize) * 1.075;

  path = font.getPath(initialsChars, initialsCanvas.width * 0.05, initialsCanvas.height * 0.95, fontSize, {});
  bbox = path.getBoundingBox();

  initialsCanvas.height = capHeight;
  path = font.getPath(initialsChars, ((initialsCanvas.width * 0.975) - (bbox.x2 - bbox.x1)) / 2, initialsCanvas.height * 0.95, fontSize, {});
  path.fill = 'rgb(255,60,255)';
  path.draw(initialsCtx);

  let event = new CustomEvent('a2.initials.drawn');
  document.dispatchEvent(event);
}